import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=24e39047&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=ts"
export * from "./TagSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e39047",
  null
  
)

export default component.exports